import { Box, Text, Image } from '@chakra-ui/react';
import Container from 'components/common/Container';
import MetaTagsHandler from 'components/common/MetaTagsHandler';
import BreadCrumb from 'components/common/BreadCrumb';
import RenderSections from 'components/common/RenderSections';

export default function BasicPages({ title, image, body, alignText, sections, metaTags, breadcrumbs, subtitle }) {
  function createDescriptionMarkup() {
    return { __html: body };
  }

  return (
    <>
      {metaTags && <MetaTagsHandler metaTags={metaTags} />}
      <Box pt="80px" pos="relative">
        <Box ml="25px" pos="absolute" top={{ base: '20px', lg: '25px' }}>
          <BreadCrumb breadcrumbs={breadcrumbs} />
        </Box>
        {image ? (
          <Box mt="-35px">
            <Image src={image} w="100%" h="auto" objectFit="contain" mb="65px" alt={title}></Image>
          </Box>
        ) : (
          ''
        )}

        <Box w="100%">
          <Container>
            <Box textAlign="center" paddingBottom={{ base: '25px', lg: '65px' }}>
              <Text
                as="h1"
                fontSize={['28px', '30px', '32px', '36px']}
                lineHeight={['32px', '36px', '38px', '45px']}
                color="brand.900"
              >
                {title}
              </Text>
            </Box>
            {subtitle ? (
              <Box>
                <Text fontSize={'16px'}>{subtitle}</Text>
              </Box>
            ) : (
              ''
            )}
            <Box mb="45px" className="content" textAlign={alignText ? alignText : 'left'}>
              <div dangerouslySetInnerHTML={createDescriptionMarkup()} />
            </Box>
            <Box className="content">
              <RenderSections sections={sections} />
            </Box>
          </Container>
        </Box>
      </Box>
    </>
  );
}
